import React, { useEffect, useState } from "react";
import { EmailVerificationForm, SignupForm } from "./components/index";
import MainLayout from "../../components/layout";
import { role, token_leads, token_user } from "../../../../helpers/auth";
import { PremiumLayoutSkeleton } from "../../../../components/page-skeleton";
import { Link, useHistory } from "react-router-dom";
import { Card } from "antd";
import Cookie from "js-cookie";
import "./styles.scss";

const SignupPage = () => {
  const [isAuthenicated, setAuthenicated] = useState(true);
  const [user, setUser] = useState(null);
  const [verificationPreview, setverificationPreview] = useState(false);
  const history = useHistory();

  const signupSuccess = (token, password) => {
    setUser({ token, password });
    setverificationPreview(true);
  };

  useEffect(() => {
    const expirationTimestamp = localStorage.getItem("expirationTimestamp");
    if (expirationTimestamp && Date.now() > parseInt(expirationTimestamp, 10)) {
      Object.keys(Cookie.get()).forEach((cookieName) => {
        Cookie.remove(cookieName);
      });
      setAuthenicated(false);
    } else if (role === "leads" && token_leads) {
      history.replace("/leads");
    } else if (role === "user" && token_user) {
      history.replace("/home");
    } else {
      setAuthenicated(false);
    }
    localStorage.removeItem("expirationTimestamp");
  }, []);

  if (isAuthenicated)
    return (
      <div className="loading-screen">
        <PremiumLayoutSkeleton />
      </div>
    );

  return (
    <MainLayout>
      <Card className="signup-wrapper">
        <h1 className="form-title">{verificationPreview ? "Email verification" : "Sign Up"}</h1>
        <p className="form-description">
          {verificationPreview
            ? "Enter the code sent to your email address"
            : <>
          Already have an account? <Link to="/">Login</Link></>}
        </p>
        {verificationPreview ? (
          <EmailVerificationForm
            token={user?.token}
            password={user?.password}
            backHandler={() => setverificationPreview(false)}
          />
        ) : (
          <SignupForm successHandler={signupSuccess} />
        )}
      </Card>
    </MainLayout>
  );
};

export default SignupPage;
